import { render } from "./allInterviewList.vue?vue&type=template&id=48afeaf1"
import script from "./allInterviewList.vue?vue&type=script&lang=js"
export * from "./allInterviewList.vue?vue&type=script&lang=js"

import "./allInterviewList.vue?vue&type=style&index=0&id=48afeaf1&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__